import * as Sentry from '@sentry/browser';

/**
 * Copy from utils/localStorage.
 * Separately defined, webpack build cannot have links to nuxt folder.
 */

export const get = (key, defaultValue = {}) => {
  try {
    if (typeof localStorage === 'undefined')
      return defaultValue;

    const serializedState = localStorage.getItem(key);

    if (serializedState === null)
      return defaultValue;

    // for none object values
    // try to parse it
    try {
      return JSON.parse(serializedState);
    } catch (e) {
      // means it's not object, so we'll return the string or number or any type
      // doesn't need to capture errors here.
      return serializedState;
    }

  } catch (err) {
    Sentry.captureException(err);

    return defaultValue;
  }
};

export const set = (key, state) => {
  try {
    if (typeof localStorage === 'undefined')
      return;

    const serializedState = JSON.stringify(state);
    return localStorage.setItem(key, serializedState);
  } catch (err) {
    Sentry.captureException(err);
  }
};

export const remove = (key) => {
  try {
    if (typeof localStorage === 'undefined')
      return;

    return localStorage.removeItem(key);
  } catch (err) {
    Sentry.captureException(err);
  }
};
